const size = {
  mobile: "480px",
  tablet: "768px",
  laptop: "992px",
  desktop: "1200px",
};

export const device = {
  mobileS: `(min-width: ${size.mobile})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  desktop: `(min-width: ${size.desktop})`,
};
